import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87831560")

_pushScopeId("data-v-87831560")
const _hoisted_1 = { class: "teacher-homepage" }
const _hoisted_2 = { class: "whiteCover" }
const _hoisted_3 = { class: "innerBox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teacherModules.list, (modules, index) => {
          return (_openBlock(), _createBlock("div", {
            class: ["square1", `square1-${index + 1}`],
            key: index,
            onClick: ($event: any) => (_ctx.teacherModules.click(modules.path))
          }, _toDisplayString(modules.name), 11, ["onClick"]))
        }), 128))
      ])
    ])
  ]))
})